enum EventStatusEnum {
  active = 'active',
  success = 'success',
  failure = 'failure',
}

export default EventStatusEnum;
